<template>
<div id="scroll-div-ranked" class="main layer2 day-ranked" style="height: calc(100% - 2rem); padding-top: 2rem; overflow: auto;">
    <div class="tt">
      <div class="type-tab">
        <span :class="rankedType === 'total' ? 'active' : ''" @click="typeClick('total')">总榜</span>
        <span :class="rankedType === 'day' ? 'active' : ''" @click="typeClick('day')">日榜</span>
        <span :class="rankedType === 'week' ? 'active' : ''" @click="typeClick('week')">周榜</span>
        <span :class="rankedType === 'month' ? 'active' : ''" @click="typeClick('month')">月榜</span>
      </div>
      <ul class="serchlist">
        <li>
          <span v-for="(item, index) in category.categoryList" :key="item.id"
                :class="{ active: getCategoryActive === item.id }"
                @click="categoryTab(item.id, 1)">{{ item.name }}</span>
        </li>
      </ul>
    </div>

    <swiper :ad-list="adList"></swiper>
    <books-small :show-title="false" :books="books.small" style="margin-top: 4.2rem;"></books-small>
    <books-large :show-title="false" :books="books.large"></books-large>
    <loading ref="loading" scroll-div="scroll-div-ranked" :is-loading="isLoading" :is-no-more-data="isNoMoreData" @get-books="getBooks(currentPage + 1)"></loading>

    <div v-if="isLoading" class="home-loading"></div>

  </div>
</template>

<script>
  import Swiper from '@/components/share/swiper'
  import BooksSmall from '@/components/share/books-small'
  import BooksLarge from '@/components/share/books-large'
  import Loading from "../../../components/share/loading";

  import listService from "../../../services/listService";

  export default {
    name: "day-ranked",
    data() {
      return {
        componentName: '',
        adList: [],
        books: {
          small: [],
          large: []
        },
        isLoading: false,
        isNoMoreData: false,
        currentPage: 1,
        category: {
          publishStatusList: [],
          categoryList: []
        },
        selected: {
          category: '0',
          publish: 'all'
        },
        rankedType:'total',
      }
    },
    computed: {
      getPublishActive() {
        return this.selected.publish
      },
      getCategoryActive() {
        console.log(this.selected.category)
        return this.selected.category
      }
    },
    methods: {
      typeClick(t){
        this.rankedType = t
        this.getBooks(1);
      },
      categoryTab(id, p){
        this.selected.category = id
        this.getBooks(p);

      },
      getCategory() {
        listService.getCategory()
          .then(res => {
            let c = {};
            c.publishStatusList = [{code: 'all', desc: '全部'}, ...res.data.publishStatusList];
            c.categoryList = [{id: '0', name: '全部'}, ...res.data.categoryList];
            this.category = c
          })
      },
      getBooks(target) {
        this.currentPage = target;
        if(target === 1) {
          this.books = {small: [], large: []}
        }
        this.isLoading = true;
        this.isNoMoreData = false;
        let _category = this.selected.category
        if(this.selected.category === 0 || this.selected.category === '0' ){
          _category = ''
        }
        listService.getMoreRank(target, _category, this.rankedType)
          // .then(res => {
          //   this.isLoading = false;
          //   this.adList = res.data.adList;
          //   if (res.data.totalPage === 0) {
          //     this.isNoMoreData = true;
          //     this.books = {small: [], large: []}
          //   } else if (this.currentPage === 1) {
          //     let data = res.data.bookList;
          //     this.books.small = data.splice(0, 3).map((item, index) => {
          //       let i = {
          //         ...item,
          //         showPop: true,
          //         popText: `NO.${index + 1 + (this.currentPage - 1) * 20}`
          //       };
          //       i.popClass = {};
          //       i.popClass[`pop-${index}`] = true;
          //       return i;
          //     });
          //     this.books.large = data.map((item, index) => {
          //       let i = {
          //         ...item,
          //         showPop: false,
          //         popText: `NO.${index + 4 + (this.currentPage - 1) * 20}`,
          //         popClass: {
          //           'pop-3': true
          //         }
          //       };
          //       return i;
          //     });
          //   } else if (this.currentPage > 1 && this.currentPage <= res.data.totalPage) {
          //     this.books.large.push(...res.data.bookList.map((item, index) => {
          //       let i = {
          //         ...item,
          //         showPop: false,
          //         popText: `NO.${index + 4 + (this.currentPage - 1) * 20}`,
          //         popClass: {
          //           'pop-3': true
          //         }
          //       }
          //     }));
          //   }
          //   if (res.data.totalPage == 0 || this.currentPage >= res.data.totalPage) {
          //     this.isNoMoreData = true;
          //   }
          //   setTimeout(() => {
          //     this.$refs['loading'].scrollFunction();
          //   }, 0)
          // })
          .then(res => {
              this.isLoading = false;
              this.adList = res.data.adList;
              this.nextPage = res.data.bookList.length === 10 ? true : false;
              if (res.data.totalPage === 0) {
                this.isNoMoreData = true;
                this.books = {small: [], large: []}
              } else if (this.currentPage === 1) {
                let data = res.data.bookList;
                this.books.small = data.splice(0, 3);
                this.books.large = data;
              } else if (this.currentPage > 1 && this.currentPage <= res.data.totalPage) {
                this.books.large.push(...res.data.bookList);
              }
              if (res.data.totalPage == 0 || this.currentPage >= res.data.totalPage) {
                this.isNoMoreData = true;
              }
            })
      }
    },
    components: {
      swiper: Swiper,
      'books-small': BooksSmall,
      'books-large': BooksLarge,
      loading: Loading
    },
    mounted() {
      this.componentName = this.$route.name;
      console.log(this.componentName, this.$store.state.pageState[this.componentName]);
      if (this.$store.state.pageState[this.componentName] && this.$router.isBack) {
        Object.assign(this.$data, this.$store.state.pageState[this.$route.name].data);
        setTimeout(() => {
          let scrollDiv = document.getElementById('scroll-div-ranked');
          scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top;
        }, 5);
      } else {
        //this.adList = swiperService.getAdList();
        this.getCategory();
        this.getBooks(1);
      }
      this.$router.isBack = true;
    },
    beforeDestroy() {
      let scrollDiv = document.getElementById('scroll-div-ranked');
      let state = {};
      state[this.componentName] = {data: this.$data, top: scrollDiv.scrollTop}
      this.$store.commit('saveState', state);
    }
  }
</script>
<style scoped>
  .home-loading{position: absolute; background:#000 url(../../../assets/images/loading4.gif) center center no-repeat; background-size: 40px; top: 0px; left: 0; right: 0; bottom: 0; z-index: 500; opacity: .5;}

</style>
<style>
.day-ranked .booklist .book-sum{height: 1.9rem;font-size: .6rem; color: #ff9a85; margin-top: 0.2rem; padding-left:1.6rem;}
.day-ranked .booklist .book-sum .icon-eye{ width: 0.8rem; height: 0.8rem; vertical-align: middle; background-size: 0.7rem 0.7rem; background-position: top center;margin-right: 0rem; opacity: .9;
  display: block; margin-bottom: .4rem;}
.day-ranked .booklist .book-sum .mr20{ display: none; }
.day-ranked .booklist li{padding-bottom: 0;}
.day-ranked .booklist li:nth-child(1) .book-sum{ background: url(../../../assets/img/top1.png) 0 -0.49rem no-repeat; background-size: 1.3rem auto;}
.day-ranked .booklist li:nth-child(2) .book-sum{background: url(../../../assets/img/top2.png) 0 -0.49rem no-repeat;  background-size: 1.3rem auto;}
.day-ranked .booklist li:nth-child(3) .book-sum{background: url(../../../assets/img/top3.png) 0 -0.49rem no-repeat;  background-size: 1.3rem auto;}

.day-ranked .type-tab{ display: flex; padding-top: .5rem;}
.day-ranked .type-tab span{ width: 24%; display: inline-block; margin: 0.3rem 0.4% 0 0.4%; text-align: center; font-size: 0.6rem; line-height: 1.5rem; border: 1px solid #e99d18; border-radius: 1rem; color: #e99d18; }
.day-ranked .type-tab span.active{ background: #e99d18; color: #fff;}
.day-ranked .serchlist li{margin: .3rem 0 .3rem 0;}
.day-ranked .serchlist li span{ margin: 0 0.1rem 0.2rem 0.1rem;  text-align: center;font-size:.5rem; background: #fff; height: 1rem; line-height: 1rem;
    border: 1px solid #b97500; padding: 0rem 0.4rem; border-radius: 1rem; color: #b97500;}
.day-ranked .serchlist li span.active{ border: 1px solid #e99d18; background: #e99d18; color: #fff;}
.day-ranked .tt{ position: fixed; top: 2rem; left: 0; right: 0; background: #202125;    z-index: 100; border-bottom: 0px solid #eee;}
</style>



// WEBPACK FOOTER //
// src/pages/layer2/books/day-ranked.vue